import config from '../config';
import axios from 'axios';

export function getProjectList() {
  return axios.get(`${config.API_BASE_URL}/project/list`);
}

export function getHomeCarousel() {
  return axios.get(`${config.API_BASE_URL}/website/index/top`);
}

export function getProjectDetail(id) {
  return axios.get(`${config.API_BASE_URL}/website/project/info/${id}`);
}

export function getHomeProjectList() {
  return axios.get(`${config.API_BASE_URL}/website/index/gcal`);
}

export function getAllProjectCases() {
  return axios.get(`${config.API_BASE_URL}/website/gcal/all`);
} 